import axios from "axios";
import { api } from "./api_route";


export const allTenant = async (values) => {
  try {
    const result = await axios.get(`${api}/tenant/all`);

    return result.data;
  } catch (error) {
    return [];
  }
};